// @owners { team: patients }
import React from 'react';
import styled from 'styled-components';

type Props = {
  readonly src: string;
  readonly alt: string;
  readonly width?: string;
  readonly height?: string;
  readonly style?: React.CSSProperties;
};

const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
`;

export const Image = ({ src, alt, width, height, style }: Props) => {
  return (
    <StyledImage
      src={src}
      alt={alt}
      width={width}
      height={height}
      style={style}
    />
  );
};
